import React, { FC } from "react";

interface DateIconProps {
  className: string;
}

const DateIcon: FC<DateIconProps> = ({ className }) => {
  return (
                        <svg  xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" color="#66797F" width="24px" height="24px"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 2.25C17 1.97386 16.7761 1.75 16.5 1.75C16.2239 1.75 16 1.97386 16 2.25V3.25H8V2.25C8 1.97386 7.77614 1.75 7.5 1.75C7.22386 1.75 7 1.97386 7 2.25V3.25H4.5C3.80964 3.25 3.25 3.80964 3.25 4.5V8.25V19.5C3.25 20.1904 3.80964 20.75 4.5 20.75H19.5C20.1904 20.75 20.75 20.1904 20.75 19.5V8.25V4.5C20.75 3.80964 20.1904 3.25 19.5 3.25H17V2.25ZM19.75 7.75V4.5C19.75 4.36193 19.6381 4.25 19.5 4.25H17V5.25C17 5.52614 16.7761 5.75 16.5 5.75C16.2239 5.75 16 5.52614 16 5.25V4.25H8V5.25C8 5.52614 7.77614 5.75 7.5 5.75C7.22386 5.75 7 5.52614 7 5.25V4.25H4.5C4.36193 4.25 4.25 4.36193 4.25 4.5V7.75H19.75ZM4.25 8.75H19.75V19.5C19.75 19.6381 19.6381 19.75 19.5 19.75H4.5C4.36193 19.75 4.25 19.6381 4.25 19.5V8.75Z" fill="currentcolor"></path></svg>


  );
};

export default DateIcon;


